module.exports = __webpack_public_path__ + "img/les-insus-live.a8508ca7.jpg";